import React from 'react'
import { observer } from 'mobx-react'
import { IoIosCloseCircle as CloseIcon } from 'react-icons/io'
import { Row } from 'react-bootstrap'
import { handleFilterCbk } from 'src/deps'

@observer
class SelectedFilters extends React.Component {
  handleRemoveFilter = (name, value) => {
    handleFilterCbk({
      props: { ...this.props },
      nameValue: { name, value: { name: value } },
    })
  }

  render() {
    const { selectedFilter, className } = this.props
    return (
      <Row noGutters className={`selected-filters ${className}`}>
        {selectedFilter.map(filter => {
          const value = filter.value.split(',')
          return value.map(data => {
            return (
              <div
                className={`mr-3 d-flex align-items-center border border-primary ml-1 flex-reverse px-3 py-2 align-self-center`}
                style={{ cursor: 'pointer' }}
                key={`${filter.field}-${data}`}>
                <span>{data}</span>
                <CloseIcon
                  size="1.5rem"
                  className="filter-close-icon ml-2 text-primary"
                  onClick={() => this.handleRemoveFilter(filter.field, data)}
                />
              </div>
            )
          })
        })}
      </Row>
    )
  }
}

export { SelectedFilters }
